import React from 'react';
import InlineEditField from './InlineEditField';

class InlineEdit extends React.Component {
  editViewRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      isEditing: this.props.editMode || false
    };
  }

  componentDidMount() {
    if (this.props.editMode && this.editViewRef.current) {
      this.editViewRef.current.focus();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.editMode !== prevProps.editMode) {
      if (this.props.editMode) {
        this.onEditRequested();
      } else {
        this.setEditState(false);
      }
    }
  }

  setEditState = (state, callback) => {
    this.setState(
      {
        isEditing: state
      },
      () => {
        if (callback) callback();
      }
    );
    if (this.props.onEditStateChange) this.props.onEditStateChange(state);
  };

  onConfirm = (value, callback) => {
    this.setEditState(false);
    this.props.onConfirm(value, callback);
  };

  onCancel = () => {
    this.props?.onCancel && this.props?.onCancel();
    this.setEditState(false);
  };

  onEditRequested = () => {
    this.setEditState(true, () => {
      if (this.editViewRef.current) {
        this.editViewRef.current.focus();
      }
    });
  };

  render() {
    return (
      <InlineEditField
        {...this.props}
        defaultValue={this.props.defaultValue}
        editView={(fieldProps) =>
          this.props.editView(fieldProps, this.editViewRef)
        }
        saveOnEnter={this.props.saveOnEnter}
        readView={this.props.readView}
        onConfirm={this.onConfirm}
        onCancel={this.onCancel}
        isEditing={this.state.isEditing}
        onEditRequested={this.onEditRequested}
        autoSave={this.props.autoSave}
        showProgress={this.props.showProgress}
      />
    );
  }
}

InlineEdit.defaultProps = {
  editMode: false
};

export default InlineEdit;
